let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let React = require('ES/lib/react');
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let Modal = require('ES/widgets/Modal');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require("react-loose-forms");
let ErrorAlert = require('ES/widgets/ErrorAlert');
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let LoadingWrap = require('ES/widgets/LoadingWrap');
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let EventFormUnsavedChangeMixin = require('../../EventFormUnsavedChangeMixin');
let getListOfSpeakersWhoCanEditMasterStoriesList = require('./getListOfSpeakersWhoCanEditMasterStoriesList');

let SIDPicker = dd.createClass({
	mixins: [FormMixin],
	getInitialValues(props){
		return {sid: props.sid};
	},
	buildSchema(){
		let speakers_I_can_manage = getListOfSpeakersWhoCanEditMasterStoriesList(this.props.Displaylists);

		return {
			sid: {
				label: 'Speaker',
				type: 'select',
				options: _.object(_.map(speakers_I_can_manage, function(spkr){
					return [spkr.sid, spkr.name_full];
				}))
			}
		};
	},
	onFormChanged(){
		this.Form_onSubmit();
	},
	render(){
		return dd.form({className: 'form-horizontal', onSubmit: this.Form_onSubmit},
			ezHorizontalFields(this)
		);
	}
});

let getSpeakerFromDisplaylists = function(sid, Displaylists){
	return _.first(_.filter(Displaylists && Displaylists.perspeaker, function(spkr){
		return sid == spkr.sid;
	}));
};

let StoriesMasterListForm = dd.createClass({
	mixins: [FormMixin, EventFormUnsavedChangeMixin],
	getInitialValues({sid, Displaylists}){
		let speaker = getSpeakerFromDisplaylists(sid, Displaylists) || {};
		return _.object(_.map(speaker.stories, function(story){
			return [story.id, story.ti];
		}));
	},
	buildSchema(){
		let {sid, Displaylists} = this.props;

		let speaker = getSpeakerFromDisplaylists(sid, Displaylists) || {};

		let story_ids = _.sortBy(_.uniq(_.difference(_.flattenDeep([
			_.map(speaker.stories, 'id'),
			this.__getCustomList("ids_to_add")
		]), this.__getCustomList("ids_to_delete"))), function(id){
			return /^new_story_/.test(id) ? id : esUtils.toInt(id);
		});

		return _.object(_.map(story_ids, function(id){
			return [id, {type: 'text'}];
		}));
	},
	__delete(id){
		let self = this;
		return esUtils.wrapPreventDefault(function(){
			self.Form_onChange("ids_to_delete", self.__getCustomList("ids_to_delete").concat([id]));
		});
	},
	__add: esUtils.wrapPreventDefault(function(){
		let ids_to_add = this.__getCustomList("ids_to_add");
		let new_id = "new_story_" + _.padLeft(_.uniqueId(), 10, '0');//padding to make the sorting work properly
		this.Form_onChange("ids_to_add", _.uniq(ids_to_add.concat([new_id])));
	}),
	__getCustomList(name){
		return _.uniq(_.flattenDeep([this.state.data && this.state.data[name]]));
	},
	render(){
		let fields = this.Form_buildSchema();
		let onClose = this.props.onClose;
		let changes_made = this.Form_areChangesMade();

		return dd.form({className: 'form-horizontal', onSubmit: this.Form_onSubmit},
			dd.button({className: 'btn btn-default btn-sm', style: {marginTop: '1.5em', marginBottom: '0.5em'}, onClick: this.__add}, dd.i({className: 'fa fa-plus'}), ' Add Story'),
			dd.div({className: 'masterstorylist'},
				_.map(fields, function(field, name){
					return dd.div({key: name, className: 'form-group', style: {marginBottom: 0}},
						dd.div({className: 'col-sm-10'},
							this.Form_buildInput(field)
						),
						dd.div({className: 'col-sm-2'},
							dd.a({href: '#', style: {display: 'inline-block', marginTop: 5}, onClick: this.__delete(name)},
								dd.i({className: 'fa fa-trash-o'}), ' delete'
							)
						)
					);
				}, this)
			),
			dd.div({className: 'form-group', style: {marginTop: '2em'}},
				dd.div({className: 'col-sm-12'},
					FormButtons({
						onCancel: onClose,
						onDiscard: changes_made ? this.__discardChanges : null,
						right_align: true
					})
				)
			)
		);
	}
});

module.exports = dd.createClass({
	propTypes: {
		event: React.PropTypes.object.isRequired,
		Displaylists: React.PropTypes.object.isRequired,
		onClose: React.PropTypes.func.isRequired
	},
	mixins: [RadioServiceMixin],
	getInitialState(){
		return {sid: _.first(this.props.event && this.props.event.sids)};
	},
	RadioService_setup(){
		return {
			StoriesList_save: {
				key(){
					return this.state.sid;
				},
				on: {
					succeeded(){
						this.props.onClose();
					}
				}
			}
		};
	},
	__pickSID({sid}){
		this.setState({sid});
	},
	__onSubmit(data){
		let ids_to_delete = _.flattenDeep(data.ids_to_delete);
		let stories = _.object(_.filter(_.map(data, function(val, key){
			if(!_.isString(val) || _.includes(ids_to_delete, key)){
				return null;
			}
			return [key, val];
		})));
		radio("StoriesList_save").broadcast({sid: this.state.sid, stories});
	},
	render(){
		let {Displaylists, onClose} = this.props;
		let sid = this.state.sid;
		let ajax = this.state.StoriesList_save;

		let speakers_I_can_manage = getListOfSpeakersWhoCanEditMasterStoriesList(Displaylists);
		if(_.size(speakers_I_can_manage) === 1){
			sid = _.first(speakers_I_can_manage).sid;
		}

		return Modal({
				title: 'Stories Master List',
				onClose: ajax.waiting ? null : onClose,
				buttons: []
			},
			ErrorAlert({message: ajax.error}),
			LoadingWrap({is_loading: ajax.waiting, text: 'Saving...'},
				dd.div({className: 'alert alert-info'},
					dd.b(null, 'NOTE: '), 'Changes applied to this list apply to ALL EVENTS and all OTHER USERS for this speaker.'
				),
				_.size(speakers_I_can_manage) > 1 ? SIDPicker({sid, Displaylists, onSubmit: this.__pickSID}) : null,
				StoriesMasterListForm({
					sid,
					onClose,
					Displaylists,
					onSubmit: this.__onSubmit
				})
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/misc/StoriesEditorModal.js